import { AsyncPipe, NgIf, NgOptimizedImage } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { SafePipe } from '@app-pipes/safe.pipe'
import { TabletsService } from '@app-services/tablets/tablets.service'
import { Observable, map } from 'rxjs'
import { TabletMessageFragment, TabletStatusEnum } from '../../generated/graphql'

@Component({
    selector: 'app-form-page',
    imports: [
        AsyncPipe,
        SafePipe,
        NgIf,
        NgOptimizedImage,
    ],
    templateUrl: './form-page.component.html',
    styleUrl: './form-page.component.scss',
    standalone: true,
})
export class FormPageComponent implements OnInit {

    public currentTabletMessage$: Observable<TabletMessageFragment | null>

    constructor(
        private readonly tabletsService: TabletsService,
    ) {
    }

    public ngOnInit(): void {
        this.currentTabletMessage$ = this.tabletsService.currentTabletMessage$.pipe(
            map((message) => {
                if (message?.status === TabletStatusEnum.FormCancelled) {
                    return null
                }
                return message
            })
        )
    }
}
